import React from 'react';
import { cn } from '../../lib/utils';

const PrimaryButton = ({ 
  children, 
  onClick, 
  className = '', 
  disabled = false,
  type = 'button',
  style = {},
  ...props 
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      style={{
        color: '#ffffff',
        ...style
      }}
      className={cn(
        // Default state
        'w-96 h-14 px-6 py-3 bg-green-700 rounded-lg',
        'inline-flex flex-col justify-center items-center gap-2.5',
        'text-center justify-center text-xl font-bold font-[\'Figtree\'] leading-normal',
        'transition-all duration-300 ease-in-out',
        'hover:shadow-[0px_15px_30px_0px_rgba(0,0,0,0.10)]',
        'hover:shadow-[0px_5px_20.100000381469727px_0px_rgba(255,255,255,0.10)]',
        'hover:shadow-[inset_0px_4px_25px_0px_rgba(255,255,255,0.35)]',
        'hover:outline hover:outline-1 hover:outline-offset-[-1px] hover:outline-white',
        'hover:backdrop-blur-[30px]',
        // Disabled state
        'disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:shadow-none',
        'disabled:hover:outline-none disabled:hover:backdrop-blur-none',
        // Custom className override
        className
      )}
      {...props}
    >
      <span className="primary-button-text" style={{ 
        color: '#ffffff !important',
        WebkitTextFillColor: '#ffffff',
        WebkitTextStroke: 'none'
      }}>
        {children}
      </span>
    </button>
  );
};

export default PrimaryButton;
